import {AxiosCall} from '../axios';

export const MarkForSubmission = async (
  groupId: number,
  clinicId: number,
  claimId: number
): Promise<any> => {
  return AxiosCall.put(
    `clinic-group/${groupId}/clinic/${clinicId}/claim/${claimId}/mark-for-submission`,
    {}
  );
};

export const IgnoreClaim = async (
  groupId: number,
  clinicId: number,
  claimId: number,
  payload: {
    notes: string;
  }
): Promise<any> => {
  return AxiosCall.put(
    `clinic-group/${groupId}/clinic/${clinicId}/claim/${claimId}/ignore`,
    payload
  );
};

export const ReverseClaim = async (
  groupId: number,
  clinicId: number,
  claimId: number
): Promise<any> => {
  return AxiosCall.put(
    `clinic-group/${groupId}/clinic/${clinicId}/claim/${claimId}/reverse`,
    {}
  );
};

export const CloseAndAdjustBalanceToPatientClaim = async (
  groupId: number,
  clinicId: number,
  claimId: number,
  params?: {
    type: string;
  }
): Promise<any> => {
  return AxiosCall.put(
    `clinic-group/${groupId}/clinic/${clinicId}/claim/${claimId}/close`,
    params
  );
};

export const getClaimFailedReasons = async (
  groupId: number,
  clinicId: number
): Promise<any> => {
  return AxiosCall.get(
    `clinic-group/${groupId}/clinic/${clinicId}/claim/failed-reasons`
  );
};

// Clinic Group Level service functions
export const deleteSelectedVaccine = async (
  groupId: number,
  org_group_form_id: string
): Promise<any> => {
  return AxiosCall.delete(
    `/clinic-group/${groupId}/patient-forms/config/${org_group_form_id}`
  );
};

export const getClinicGroupLevelVaccinesTableList = async (
  groupdId: number
): Promise<any> => {
  return AxiosCall.get(`/clinic-group/${groupdId}/vaccine/config`);
};

export const getAvailableVaccinesList = async (
  groupId: number
): Promise<any> => {
  return AxiosCall.get(`/clinic-group/${groupId}/vaccine/all`);
};

export const addVaccineConfig = async (
  groupId: number,
  vaccineId: number,
  payload: {
    vaccine_price: number;
    service_charge: number;
    service_description: string;
    service_notes: string;
  }
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${groupId}/vaccine/${vaccineId}/config`,
    payload
  );
};

export const updateVaccineConfig = async (
  groupId: number,
  vaccineId: number,
  payload: {
    vaccine_price: number;
    service_charge: number;
    service_description: string;
    service_notes: string;
  }
): Promise<any> => {
  return AxiosCall.post(
    `/clinic-group/${groupId}/vaccine/${vaccineId}/config`,
    payload
  );
};

export const getVaccineDetailsById = async (
  groupId: number,
  Id: number
): Promise<any> => {
  return AxiosCall.get(`clinic-group/${groupId}/vaccine/config/${Id}`);
};

// System Level Service functions
export const getSystemLevelVaccinesTableList = async (): Promise<any> => {
  return AxiosCall.get(`/vaccine/config`);
};

export const getSystemLevelVaccinesList = async (): Promise<any> => {
  return AxiosCall.get(`/vaccine/all`);
};

export const addSystemlevelVaccine = async (payload: {
  proprietary_name: string;
  ndc_code?: string;
  quantity?: number;
  vaccine_price_description?: string;
  service_charge_description?: string;
  vaccine_price: number;
  service_charge: number;
  service_description: string;
  service_notes: string;
}): Promise<any> => {
  return AxiosCall.post(`/vaccine/config`, payload);
};

export const updateSystemlevelVaccine = async (
  vaccineId: number,
  payload: {
    vaccine_price: number;
    service_charge: number;
    service_description: string;
    service_notes: string;
    ndc_code?: string;
    quantity?: number;
    vaccine_price_description?: string;
    service_charge_description?: string;
  }
): Promise<any> => {
  return AxiosCall.post(`/vaccine/${vaccineId}/config`, payload);
};

export const getSystemLevelVaccineDetailsById = async (
  Id: number
): Promise<any> => {
  return AxiosCall.get(`vaccine/config/${Id}`);
};
